var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3671_10351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.35 17.1429L16.578 12L10.35 6.85714V17.1429ZM24.222 3.72C24.378 4.52571 24.486 5.60571 24.558 6.97714C24.642 8.34857 24.678 9.53143 24.678 10.56L24.75 12C24.75 15.7543 24.558 18.5143 24.222 20.28C23.922 21.8229 23.226 22.8171 22.146 23.2457C21.582 23.4686 20.55 23.6229 18.966 23.7257C17.406 23.8457 15.978 23.8971 14.658 23.8971L12.75 24C7.722 24 4.59 23.7257 3.354 23.2457C2.274 22.8171 1.578 21.8229 1.278 20.28C1.122 19.4743 1.014 18.3943 0.942 17.0229C0.858 15.6514 0.822 14.4686 0.822 13.44L0.75 12C0.75 8.24571 0.942 5.48571 1.278 3.72C1.578 2.17714 2.274 1.18286 3.354 0.754286C3.918 0.531429 4.95 0.377143 6.534 0.274285C8.094 0.154285 9.522 0.102857 10.842 0.102857L12.75 0C17.778 0 20.91 0.274286 22.146 0.754286C23.226 1.18286 23.922 2.17714 24.222 3.72Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3671_10351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f6d69991.svg";
export { ForwardRef as ReactComponent };